import { ReserveFragmentComponent } from './User/Reserve/ReserveFragmentComponent';
import { PaymentFragmentComponent } from './User/Payment/PaymentFragmentComponent';
import { MatDialog } from '@angular/material/dialog';
import { MyPageFragmentComponent } from './User/MyPage/MyPageFragmentComponent';
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { BaseDisplay } from 'src/app/View/BaseUI/BaseDisplay';
import { MainDisplayController } from './MainDisplayController';
import { AppSingletonUtil } from 'src/app/Util/AppSingletonUtil';
import { AppSetting } from 'src/app/AppSetting';
import { DiagnoseFragmentComponent } from './User/Diagnose/DiagnoseFragmentComponent';
import { PcrInterviewFragmentComponent } from './User/PcrInterview/PcrInterviewFragmentComponent';
import { IonModal } from '@ionic/angular';
import { HomeFragmentComponent } from './User/Home/HomeFragmentComponent';

@Component({
	selector: 'app-main',
	templateUrl: './MainDisplayComponent.html',
	styleUrls: ['./MainDisplayComponent.scss'],
})
export class MainDisplayComponent extends BaseDisplay {


	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのコントローラーと紐づくか明示する為。
	public combineCtrl: MainDisplayController;

	// メインのディスプレイまたはフラグメントを差し込むコンテナ
	@ViewChild('childFragmentContainer', { read: ViewContainerRef, static: false })
	private childFragmentContainer: ViewContainerRef;
	@ViewChild(IonModal) modal: IonModal;
	// 表示するDisplay、Fragmentのインスタンス
	private childView: BaseDisplay;

	public eventShowHome = this.onClickShowHome.bind(this);
	public eventShowMedicalService = this.onClickShowDiagnose.bind(this);
	public eventShowCredit = this.onClickShowPayment.bind(this);
	public eventShowReserve = this.onClickShowReserve.bind(this);
	public eventShowSetting = this.onClickShowMyPage.bind(this);

	// パスワード再設定時のエラー表示
	public error: {isValid: boolean; text: string} = {isValid: false, text: ''};

	constructor(
		public dialogCtrl: MatDialog,
	) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		// BaseViewでコントローラのインスタンスを作成して保持する（ロジック系はコントローラに実装する）
		this.createController(MainDisplayController);

		// EVENT_LISTに定義したイベントを登録する。
		this.registerEvent();
	}


	/**
	 * start
	 * 初期化処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

		// ストレージに検体番号があるかチェックする
		// 存在した場合はその値とともに、問診画面表示
		const isExist = await this.combineCtrl.isExistSpecimenNum({view: this});
		if (isExist) {
			const inst = await this.renewStartComponent(PcrInterviewFragmentComponent, this.childFragmentContainer);
			inst.eventShowMain = this.onClickShowDiagnose.bind(this);
			return;
		}

		// パスワードが存在しない場合はリセットダイアログ表示
		const isExistPass = await this.combineCtrl.isExistPassword({view: this});
		if (!isExistPass) {
			this.modal.present();
		}

		// 最初のViewを表示する
		await this.onClickShowHome();

	}


	public async onClickRegisterPassword(password: string, confirm: string) {

		if (password.length < 8 && confirm.length < 8) {
			this.error.isValid = false;
			this.error.text = '8文字以上で入力してください。';
			return;
		}
		if (password !== confirm) {
			this.error.isValid = false;
			this.error.text = '入力されたパスワードが異なります。';
			return;
		}

		// パスワード設定
		await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.createPassword.bind(this),
			{view: this, password}
		);

		return this.modal.dismiss();
	}


	///////////////////////////////////
	// 画面遷移
	// ホームに遷移する
	public async onClickShowHome() {
		// 最初のViewを表示する
		const inst = await this.renewStartComponent(HomeFragmentComponent, this.childFragmentContainer) as HomeFragmentComponent;
		inst.eventShowMedicalService = this.onClickShowDiagnose.bind(this);
		inst.eventShowCreditService = this.onClickShowPayment.bind(this);
		inst.eventShowSettings = this.onClickShowMyPage.bind(this);
		inst.eventShowReserve = this.onClickShowReserve.bind(this);
	}

	// 設定に遷移する
	public async onClickShowMyPage() {
		// 最初のViewを表示する
		await this.renewStartComponent(MyPageFragmentComponent, this.childFragmentContainer);
	}

	// 検査結果画面を表示する
	public async onClickShowDiagnose() {

		// 最初のViewを表示する
		await this.renewStartComponent(DiagnoseFragmentComponent, this.childFragmentContainer);

	}

	// 請求画面を表示する
	public async onClickShowPayment() {

		// 最初のViewを表示する
		await this.renewStartComponent(PaymentFragmentComponent, this.childFragmentContainer);

	}

	// 請求画面を表示する
	public async onClickShowReserve() {

		// 最初のViewを表示する
		await this.renewStartComponent(ReserveFragmentComponent, this.childFragmentContainer);

	}

}
